import { getCurrentLocale } from '@disy/lib/locale';

/**
 * Checks whether a number is defined without faling at 0 or ''. Returns true for NaN.
 *
 * @param value a number or string that will be treated as number later.
 */
export function isNumberValueDefined(value: string | number | undefined | null) {
  return value !== undefined && value !== null && value !== '';
}

/**
 * Parses a number string with locale-specific decimal and grouping separators to a number or `NaN`.
 *
 * @param value a string value representing number in current locale
 */
export function parseNumber(value: string): number {
  const { group, decimal } = getLocaleSeparators();
  // Digit grouping is not relevant for the number parsing. Also, different languages
  // group differently (see https://en.wikipedia.org/wiki/Decimal_separator#Digit_grouping).
  // So we just ignore the grouping separators.
  const preparedValue = value.trim().replaceAll(group, '').replaceAll(decimal, '.');
  return preparedValue ? Number(preparedValue) : NaN;
}

function getLocaleSeparators() {
  // Using hardcoded value with decimal point, so the result must be there
  const [, { value: group }, , { value: decimal }] = new Intl.NumberFormat(getCurrentLocale()).formatToParts(1000.1);
  return { decimal, group };
}
